<template>
  <v-dialog
    v-if="state.active"
    max-width="680px"
    :model-value="show"
    @update:model-value="!state.loadingAdd && $emit('update:show', $event)"
    :fullscreen="$vuetify.display.xs"
  >
    <template v-if="state.activeForm === 'meeting'">
      <form @submit.prevent="addMeeting">
        <v-card>
          <v-card-title>
            <div class="d-flex align-center justify-space-between">
              <typography>Add Meeting</typography>
              <v-btn
                color="black"
                icon
                variant="text"
                @click="$emit('update:show', false)"
                :disabled="state.loadingAdd"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
          </v-card-title>
          <v-divider class="m-0"></v-divider>
          <v-card-item>
            <div class="add-meeting-inputs d-flex flex-column gap-4 pt-2">
              <div>
                <Typography>
                  Time:
                  <typography>
                    {{ dayjs(props.timeslot).format("h:mm A") }}
                  </typography>
                </Typography>
              </div>
              <div>
                <autocomplete
                  :items="students"
                  color="black"
                  variant="outlined"
                  bg-color="white"
                  density="compact"
                  class="custom-input"
                  v-model="state.student"
                  item-title="label"
                  item-value="value"
                  clearable
                  label="Student"
                  :max-items="50"
                  :empty-slot="
                    schoolStore.school?.integration === 'none'
                      ? {
                          text: 'Add a new Student',
                          onClick: () => (state.activeForm = 'student')
                        }
                      : undefined
                  "
                >
                </autocomplete>
                <FormValidate
                  :validate="state.student"
                  title="student must be selected"
                ></FormValidate>
              </div>
              <div>
                <autocomplete
                  :items="parents"
                  color="black"
                  variant="outlined"
                  bg-color="white"
                  density="compact"
                  class="custom-input"
                  v-model="state.parent"
                  item-title="label"
                  item-value="value"
                  clearable
                  label="Parent"
                  :max-items="50"
                  :empty-slot="
                    schoolStore.school?.integration === 'none'
                      ? {
                          text: 'Add a new Parent',
                          onClick: () => (state.activeForm = 'parent')
                        }
                      : undefined
                  "
                >
                </autocomplete>
                <FormValidate
                  :validate="state.parent"
                  title="parent must be selected"
                ></FormValidate>
              </div>
              <div v-if="authStore.me.modify_schedule && availableMeetingTypes.length > 0">
                <v-select
                  :items="availableMeetingTypes"
                  v-model="state.meetingType"
                  item-title="label"
                  item-value="value"
                  color="black"
                  variant="outlined"
                  bg-color="white"
                  density="compact"
                  class="custom-input"
                  label="Meeting Type"
                  clearable
                >
                </v-select>
              </div>
            </div>
          </v-card-item>
          <v-divider class="mt-4 mb-1"></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              :disabled="!(state.parent && state.student)"
              type="submit"
              :loading="state.loadingAdd"
              >add meeting</v-btn
            >
          </v-card-actions>
        </v-card>
      </form>
    </template>
    <template v-if="state.activeForm === 'student'">
      <form @submit.prevent="addStudent">
        <v-card>
          <v-card-title>
            <div class="d-flex align-center justify-space-between">
              <typography>Add Student</typography>
              <v-btn color="black" icon variant="text" @click="$emit('update:show', false)">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
          </v-card-title>
          <v-divider class="m-0"></v-divider>
          <v-card-item>
            <div class="add-meeting-inputs d-flex flex-column gap-4 pt-2">
              <div>
                <autocomplete
                  :items="parents"
                  color="black"
                  variant="outlined"
                  bg-color="white"
                  density="compact"
                  class="custom-input"
                  v-model="state.parent"
                  item-title="label"
                  item-value="value"
                  clearable
                  label="Parent"
                  placeholder="optional"
                  :max-items="50"
                  :empty-slot="
                    schoolStore.school?.integration === 'none'
                      ? {
                          text: 'Add a new Parent',
                          onClick: () => (state.activeForm = 'parent')
                        }
                      : undefined
                  "
                >
                </autocomplete>
              </div>
              <div>
                <v-text-field
                  label="Student First Name *"
                  class="custom-input"
                  v-model="studentModal.fname"
                  required
                >
                </v-text-field>
              </div>
              <div>
                <v-text-field
                  label="Student Last Name *"
                  class="custom-input"
                  v-model="studentModal.lname"
                  required
                >
                </v-text-field>
              </div>
              <div>
                <v-text-field
                  label="External ID *"
                  class="custom-input"
                  v-model="studentModal.external_id"
                  required
                >
                </v-text-field>
              </div>
            </div>
          </v-card-item>
          <v-divider class="mt-4 mb-1"></v-divider>
          <v-card-actions>
            <v-btn @click="state.activeForm = 'meeting'" :disabled="studentModal.loading"
              >cancel</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn type="submit" :loading="studentModal.loading">add student</v-btn>
          </v-card-actions>
        </v-card>
      </form>
    </template>
    <template v-if="state.activeForm === 'parent'">
      <form @submit.prevent="addParent">
        <v-card>
          <v-card-title>
            <div class="d-flex align-center justify-space-between">
              <typography>Add Parent</typography>
              <v-btn color="black" icon variant="text" @click="$emit('update:show', false)">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
          </v-card-title>
          <v-divider class="m-0"></v-divider>
          <v-card-item>
            <div class="add-meeting-inputs d-flex flex-column gap-4 pt-2">
              <div>
                <autocomplete
                  :items="students"
                  color="black"
                  variant="outlined"
                  bg-color="white"
                  density="compact"
                  class="custom-input"
                  v-model="state.student"
                  item-title="label"
                  item-value="value"
                  clearable
                  label="Student"
                  placeholder="Optional"
                  :max-items="50"
                  :empty-slot="
                    schoolStore.school?.integration === 'none'
                      ? {
                          text: 'Add a new Student',
                          onClick: () => (state.activeForm = 'student')
                        }
                      : undefined
                  "
                >
                </autocomplete>
              </div>
              <div>
                <v-text-field
                  label="Parent First Name *"
                  class="custom-input"
                  v-model="parenModal.fname"
                  required
                >
                </v-text-field>
              </div>
              <div>
                <v-text-field
                  label="Parent Last Name *"
                  class="custom-input"
                  v-model="parenModal.lname"
                  required
                >
                </v-text-field>
              </div>
              <div>
                <v-text-field
                  label="Email *"
                  class="custom-input"
                  v-model="parenModal.email"
                  required
                  type="email"
                >
                </v-text-field>
              </div>
            </div>
          </v-card-item>
          <v-divider class="mt-4 mb-1"></v-divider>
          <v-card-actions>
            <v-btn @click="state.activeForm = 'meeting'" :disabled="parenModal.loading"
              >cancel</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn type="submit" :loading="parenModal.loading">add parent</v-btn>
          </v-card-actions>
        </v-card>
      </form>
    </template>
  </v-dialog>
</template>

<script setup lang="tsx">
import type { ConferenceDay, NestedStudent, NestedGuardian } from "@/api_types/teacher";
import FormValidate from "@/components/formValidate.vue";
import Typography from "@/components/typography.vue";
import FetchService from "@/services/fetch.service";
import { useAlertsStore } from "@/stores/alerts";
import { useAuthenticationStore } from "@/stores/authentication";
import { useConferenceStore } from "@/stores/teacher/conference";
import { useSchoolStore } from "@/stores/school";
import dayjs from "dayjs";
import { computed, reactive, watch } from "vue";
import Autocomplete from "@/components/autocomplete.vue";

const props = defineProps<{ show: boolean; timeslot: string; conferenceDay: ConferenceDay }>();
const emit = defineEmits<{
  (event: "update:show", show: boolean): void;
  (event: "update:slot", data: any): void;
}>();

const authStore = useAuthenticationStore();
const schoolStore = useSchoolStore();
const confStore = useConferenceStore();
const snackbar = useAlertsStore();

const state = reactive({
  student: "",
  parent: "",
  activeForm: "meeting" as "meeting" | "student" | "parent",
  active: false,
  loadingAdd: false,
  meetingType: ""
});

const parenModal = reactive({
  fname: "",
  lname: "",
  email: "",
  loading: false
});

const studentModal = reactive({
  fname: "",
  lname: "",
  external_id: "",
  loading: false
});
const students = computed(() => {
  let students = authStore.me.students as any as NestedStudent[];
  if (state.parent && schoolStore.school?.integration != "none")
    students = authStore.me.guardians.find((g) => g.uid === state.parent)?.students || students;
  if (state.parent && schoolStore.school?.integration == "none") {
    if (!authStore.me.guardians.find((g) => g.uid == state.parent)?.students.length)
      students = authStore.me.students as any;
    else
      students = authStore.me.students.filter(
        (s) => s.uid == state.student || s.guardians.find((g) => g.uid === state.parent)
      ) as any;
  }

  return (
    students.map((s) => ({
      label: s.child_fname + " " + s.child_lname,
      value: s.uid
    })) || []
  );
});

const parents = computed(() => {
  let guardians = authStore.me.guardians as NestedGuardian[];
  if (state.student && schoolStore.school?.integration != "none")
    guardians = authStore.me.students.find((s) => s.uid === state.student)?.guardians || guardians;
  if (state.student && schoolStore.school?.integration == "none")
    if (!authStore.me.students.find((s) => s.uid === state.student)?.guardians.length)
      guardians = authStore.me.guardians;
    else
      guardians = authStore.me.guardians.filter(
        (g) => g.uid === state.parent || g.students.find((s) => s.uid === state.student)
      );
  return guardians?.map((g) => ({ label: g.firstname + " " + g.lastname, value: g.uid })) || [];
});

const getAvailableMeetingTypes = (meetingTypes: any): Array<{ value: string; label: string }> => {
  if (!meetingTypes) return [];
  
  const types = typeof meetingTypes === "string" ? JSON.parse(meetingTypes) : meetingTypes;
  
  const availableTypes: Array<{ value: string; label: string }> = [];
  
  if (types.in_person) availableTypes.push({ value: "in_person", label: "In Person" });
  if (types.virtual) availableTypes.push({ value: "virtual", label: "Virtual" });
  if (types.phone) availableTypes.push({ value: "phone", label: "Phone" });
  if (types.callback) availableTypes.push({ value: "callback", label: "Callback" });
  
  return availableTypes;
};

const availableMeetingTypes = computed(() => {
  return getAvailableMeetingTypes(props.conferenceDay.meeting_types);
});

watch([() => state.activeForm], () => {
  if (!parents.value.find((p) => p.value === state.parent)) state.parent = "";
  if (!students.value.find((p) => p.value === state.student)) state.student = "";
});

let tout = 0;
watch(
  () => props.show,
  () => {
    if (props.show) {
      state.active = true;
      clearTimeout(tout);
      
      // Set default to first available meeting type if teacher has permission
      if (authStore.me.modify_schedule && availableMeetingTypes.value.length > 0 && !state.meetingType) {
        state.meetingType = availableMeetingTypes.value[0].value;
      }
    } else {
      clearTimeout(tout);
      // Reset meeting type when modal closes
      state.meetingType = "";

      tout = window.setTimeout(() => {
        state.active = false;
      }, 500);
    }
  }
);

const parentStudentRelation = async (parent_uid, children_uid) => {
  const res = await FetchService.fetchData(`/teachers/-/attach`, "put", {
    children_uid,
    parent_uid
  });
  if (res?.status !== true) {
    useAlertsStore().addAlert("error", "Failed to add student parent relation");
  }
  return res;
};

const addParent = async () => {
  parenModal.loading = true;
  const res = await FetchService.fetchData("/guardians", "post", {
    firstname: parenModal.fname,
    lastname: parenModal.lname,
    email: parenModal.email
  });
  if (res?.uid) {
    useAlertsStore().addAlert("success", "Parent Added Successfully");
    authStore.me.guardians.push(res);
    state.parent = res.uid;

    if (state.student) await parentStudentRelation(res.uid, state.student);

    await authStore.fetchProfile();
    state.activeForm = "meeting";
  }
  parenModal.loading = false;
};
const addStudent = async () => {
  studentModal.loading = true;
  const res = await FetchService.fetchData("/students", "post", {
    child_fname: studentModal.fname,
    child_lname: studentModal.lname,
    external_id: studentModal.external_id
  });
  if (res?.uid) {
    useAlertsStore().addAlert("success", "Student Added Successfully");
    authStore.me.students.push(res);
    state.student = res.uid;

    if (state.parent) await parentStudentRelation(state.parent, res.uid);

    await authStore.fetchProfile();
    state.activeForm = "meeting";
  }
  studentModal.loading = false;
};
const addMeeting = async () => {
  let relationRes,
    adding = false;
  if (!(state.parent && state.student)) return;
  state.loadingAdd = true;
  if (
    schoolStore.school?.integration == "none" &&
    (!authStore.me.students
      .find((s) => s.uid === state.student)
      ?.guardians.find((g) => g.uid == state.parent) ||
      !authStore.me.guardians
        .find((s) => s.uid === state.parent)
        ?.students.find((s) => s.uid == state.student))
  ) {
    adding = true;
    relationRes = await parentStudentRelation(state.parent, state.student);
  }
  if (!adding || relationRes?.status === true) {
    const appointment: any = {
      school_id: authStore.me.school_id,
      children_uid: state.student,
      parent_uid: state.parent,
      team_uid: confStore.selected?.team?.uid || undefined,
      timeslot: props.timeslot,
      conference_id: confStore.selected?.conference_id,
      conference_days_id: props.conferenceDay.conference_days_id
    };
    
    // Add meeting_type if teacher has permission and it's set
    if (authStore.me.modify_schedule && state.meetingType) {
      appointment.meeting_type = state.meetingType;
    }
    
    const res = await FetchService.fetchData("/schedule", "post", {
      appointment
    });
    console.log(res);

    if (res?.status) {
      snackbar.addAlert(
        "error",
        res.message ?? "unexpected error occurred, please try again later",
        7
      );
    } else {
      emit("update:slot", res);
    }
    emit("update:show", false);
  }
  state.loadingAdd = false;
};
</script>

<style scoped lang="scss">
@use "@/assets/_vars.scss" as *;
@use "@/assets/_breakpoints.scss" as breakpoints;
</style>
